/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ApiExperiment, ApiListExperimentsResponse, GoogleRpcStatus } from '../models/index';
import {
  ApiExperimentFromJSON,
  ApiExperimentToJSON,
  ApiListExperimentsResponseFromJSON,
  ApiListExperimentsResponseToJSON,
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
} from '../models/index';

export interface ArchiveExperimentRequest {
  id: string;
}

export interface CreateExperimentRequest {
  experiment: ApiExperiment;
}

export interface DeleteExperimentRequest {
  id: string;
}

export interface GetExperimentRequest {
  id: string;
}

export interface ListExperimentsRequest {
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  filter?: string;
  resource_reference_key_type?: ListExperimentsV1ResourceReferenceKeyTypeEnum;
  resource_reference_key_id?: string;
}

export interface UnarchiveExperimentRequest {
  id: string;
}

/**
 *
 */
export class ExperimentServiceApi extends runtime.BaseAPI {
  /**
   * Archives an experiment and the experiment\'s runs and jobs.
   */
  async archiveExperimentRaw(
    requestParameters: ArchiveExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling archiveExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/experiments/{id}:archive`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Archives an experiment and the experiment\'s runs and jobs.
   */
  async archiveExperiment(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.archiveExperimentRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Creates a new experiment.
   */
  async createExperimentRaw(
    requestParameters: CreateExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiExperiment>> {
    if (requestParameters['experiment'] == null) {
      throw new runtime.RequiredError(
        'experiment',
        'Required parameter "experiment" was null or undefined when calling createExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/experiments`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiExperimentToJSON(requestParameters['experiment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiExperimentFromJSON(jsonValue));
  }

  /**
   * Creates a new experiment.
   */
  async createExperiment(
    experiment: ApiExperiment,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiExperiment> {
    const response = await this.createExperimentRaw({ experiment: experiment }, initOverrides);
    return await response.value();
  }

  /**
   * Deletes an experiment without deleting the experiment\'s runs and jobs. To avoid unexpected behaviors, delete an experiment\'s runs and jobs before deleting the experiment.
   */
  async deleteExperimentRaw(
    requestParameters: DeleteExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling deleteExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/experiments/{id}`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes an experiment without deleting the experiment\'s runs and jobs. To avoid unexpected behaviors, delete an experiment\'s runs and jobs before deleting the experiment.
   */
  async deleteExperiment(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteExperimentRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds a specific experiment by ID.
   */
  async getExperimentRaw(
    requestParameters: GetExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiExperiment>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/experiments/{id}`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiExperimentFromJSON(jsonValue));
  }

  /**
   * Finds a specific experiment by ID.
   */
  async getExperiment(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiExperiment> {
    const response = await this.getExperimentRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds all experiments. Supports pagination, and sorting on certain fields.
   */
  async listExperimentsRaw(
    requestParameters: ListExperimentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiListExperimentsResponse>> {
    const queryParameters: any = {};

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    if (requestParameters['resource_reference_key_type'] != null) {
      queryParameters['resource_reference_key.type'] =
        requestParameters['resource_reference_key_type'];
    }

    if (requestParameters['resource_reference_key_id'] != null) {
      queryParameters['resource_reference_key.id'] = requestParameters['resource_reference_key_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/experiments`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiListExperimentsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds all experiments. Supports pagination, and sorting on certain fields.
   */
  async listExperiments(
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    filter?: string,
    resource_reference_key_type?: ListExperimentsV1ResourceReferenceKeyTypeEnum,
    resource_reference_key_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiListExperimentsResponse> {
    const response = await this.listExperimentsRaw(
      {
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        filter: filter,
        resource_reference_key_type: resource_reference_key_type,
        resource_reference_key_id: resource_reference_key_id,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Restores an archived experiment. The experiment\'s archived runs and jobs will stay archived.
   */
  async unarchiveExperimentRaw(
    requestParameters: UnarchiveExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling unarchiveExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/experiments/{id}:unarchive`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Restores an archived experiment. The experiment\'s archived runs and jobs will stay archived.
   */
  async unarchiveExperiment(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.unarchiveExperimentRaw({ id: id }, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ListExperimentsV1ResourceReferenceKeyTypeEnum = {
  UNKNOWN_RESOURCE_TYPE: 'UNKNOWN_RESOURCE_TYPE',
  EXPERIMENT: 'EXPERIMENT',
  JOB: 'JOB',
  PIPELINE: 'PIPELINE',
  PIPELINE_VERSION: 'PIPELINE_VERSION',
  NAMESPACE: 'NAMESPACE',
} as const;
export type ListExperimentsV1ResourceReferenceKeyTypeEnum =
  (typeof ListExperimentsV1ResourceReferenceKeyTypeEnum)[keyof typeof ListExperimentsV1ResourceReferenceKeyTypeEnum];
